<template>
  <div class="report-wrapper" v-if='data'>
    <p class="time_range">{{formatTime(data.start_time)}} - {{formatTime(data.end_time)}}</p>
    <p class="report_name">{{data.course_name}}{{data.report_name}}</p>
    <div class="info_detail">
      <img :src="data.head_portrait">
      <p class="user_name">{{data.user_name}}</p>
      <div class="statistics">
        <div><p><span>学习总时长</span><span class="learn_num"><b>{{data.learning_statistics.learning_time}}</b>小时</span></p></div>
        <div><p><span>学习总天数</span><span class="learn_num"><b>{{data.learning_statistics.days}}</b>天</span></p></div>
        <div><p><span>课件完成数</span><span class="learn_num"><b>{{data.learning_statistics.course_num}}</b>个</span></p></div>
      </div>
    </div>
    <div class="live_detail">
      <p class="live_title">
        <span class="font_bold">直播<span class="supplementary">共{{data.learning_statistics.live_num}}节直播,出勤{{data.learning_statistics.live_attendance_num}}节</span></span>
        <span v-if='data.learning_statistics.live_num' class="godetail" @click='goToLive'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <div class="canvas">
        <p>
          <el-progress type="circle" :percentage="(data.learning_statistics.effective_live_attendance_num/data.learning_statistics.live_attendance_num)*100" color='#d44940' width="70" 
            :format='live_total(data.learning_statistics.effective_live_attendance_num, data.learning_statistics.live_num)'>
          </el-progress>
          <span>有效出勤数</span>
        </p>
        <p>
          <el-progress type="circle" color='#d44940' width="70" :format='live_total(data.learning_statistics.live_learning_time)'></el-progress>
          <span>直播净观看时长/h</span>
        </p>
        <p>
          <el-progress type="circle" color='#d44940' width="70" :format='live_total(data.learning_statistics.playback_learning_time)'></el-progress>
          <span>回放净观看时长/h</span>
        </p>
      </div>
      <div class="introduce"><span></span>有效出勤：直播观看达45分钟或回放观看达50%</div>
    </div>
    <div class="video_detail">
      <p class="live_title"><span class="font_bold">视频</span></p>
      <p class="cumulative_duration">累计观看时长：{{data.learning_statistics.video_learning_time}}小时</p>
    </div>
    <div v-if='data.bc_id == 0' class="homework_detail">
      <p class="live_title">
        <span class="font_bold">作业<span v-if="ua">可登录学习APP及时处理未完成作业</span></span>
        <span v-if='!ua' class="godetail" @click='goHomeWork'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <p>正确率：{{data.learning_statistics.assign_correct_rate}}</p>
    </div>
    <div v-else class="homework_detail">
      <p class="live_title">
        <span class="font_bold">作业<span v-if="ua">可登录学习APP及时处理未完成作业</span></span>
        <span v-if='!ua' class="godetail" @click='goHomeWork'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <p>完成数：{{data.learning_statistics.homework_finish_total}} / {{data.learning_statistics.homework_total}}<span class="right_total">正确率：{{data.learning_statistics.homework_rate}}</span></p>
      <p>平均分：{{data.learning_statistics.homework_score}}</p>
    </div>
    <div class="message_detail" v-if="data.class_teacher_msg||data.lecturer_msg||data.assistant_msg">
      <p class="live_title"><span class="font_bold">老师留言</span></p>
      <div class="message_div" v-if="data.class_teacher_msg">
        <p class="message_title">班主任留言</p>
        <p v-html='data.class_teacher_msg.suggest'></p>
      </div>
      <div class="message_div" v-if="data.lecturer_msg">
        <p class="message_title">讲师留言</p>
        <p v-html='data.lecturer_msg.suggest'></p>
      </div>
      <div class="message_div" v-if="data.assistant_msg">
        <p class="message_title">助教留言</p>
        <p v-html='data.assistant_msg.suggest'></p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      data: '',
      ua: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    };
  },
  mounted() {
    this.getreport()
  },
  methods: {
    goToLive() {
      var data = {
        system_order_num: this.data.system_order_num,
        sso_id: this.data.sso_id,
        business_id: this.data.bc_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goLive'
      }
      if (this.ua) {
        this.$router.push({
          path: "/attendance",
          query: {
            ticket: this.$route.query.ticket,
            sn: this.data.system_order_num,
            bc_id: this.data.bc_id,
            st: this.data.start_time,
            et: this.data.end_time
          }
        });
      } else if (this.isAndroid) {
        window.androidJS.goLive(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goHomeWork() {
      if (this.isAndroid) {
        window.androidJS.goHomeWork();
      } else if (this.isiOS) {
        var action = 'goHomeWork'
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(action);
      }
    },
    wx_homework () {
      if (this.ua) {
        Toast("可登录学习APP及时处理未完成作业");
      }
    },
    getreport () {
      this.$api.STUDYREPORT({
        "offcn-ticket": this.$route.query.ticket,
        report_id: this.$route.query.report_id
      }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          var share = {
            share_qr: res.data.share_qr,
            share_title: res.data.share_title,
            share_note: res.data.share_note,
            share_content: res.data.share_content,
            action: 'getShare'
          }
          if (this.isAndroid) {
            window.androidJS.getShare(JSON.stringify(share));
          } else if (this.isiOS) {
            window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(share));
          }
        }
      })
    },
    live_total (val, vals) {
      val = String(val)
      vals = String(vals);
      if (vals && vals!='undefined') {
        return () => {
          return val + '/' +vals
        }
      } else {
        return () => {
          return val;
        }
      }
    },
    formatTime (timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      return year + '.' + this.addZero(month) + '.' + this.addZero(date);
    },
    addZero (m) {
      return m < 10 ? '0' + m : m
    }
  }
};
</script>

<style lang="less" scoped>
.el-progress-circle__track {
  stroke: #e6e6e6;
}
.el-progress__text {
  font-size: 36px!important;
}
.report-wrapper {
  width: 100%;
  min-height: 100%;
  padding: 40px;
  background: url('./static/images/top_bg.png') no-repeat;
  background-size: contain;
  color: #333333;
  background-color: #F3F3F3;
  .time_range, .report_name {
    text-align: center;
    color: #ffffff;
    font-size: 30px;
  }
  .report_name {
    font-size: 36px;
    margin-top: 20px;
    font-weight: bold;
  }
  .statistics {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    font-size: 24px;
    height: 60px;
    div {
      width: 224px;
      display: flex;
      justify-content: center;
      p {
        display: flex;
        flex-direction: column;
        text-align: left;
        .learn_num {
          color: #999999;
          b {
            font-size: 62px;
            color: #d44940;
            margin-right: 4px;
          }
        }
      }
      p:nth-child(2) {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
      }
    }
  }
  .info_detail {
    width: 100%;
    height: 330px;
    border-radius: 20px;
    background: #ffffff;
  }
  .live_detail, .video_detail, .homework_detail, .message_detail {
    width: 100%;
    padding: 50px 30px 50px 40px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 30px;
    font-size: 30px;
    .live_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .font_bold {
        position: relative;
        font-size: 32px;
        font-weight: bold;
        span {
          color: #666666;
          font-size: 24px;
          font-weight: normal;
          margin-left: 10px;
        }
        &:before {
          content: '';
          position: absolute;
          top: 6px;
          left: -20px;
          width: 10px;
          height: 32px;
          background: #d33f3a;
          border-radius: 5px;
        }
        .supplementary {
          font-size: 24px;
          font-weight: normal;
          color: #666666;
          margin-left: 20px;
        }
      }
    }
    .right_total {
      margin-left: 70px;
    }
    .godetail {
      font-size: 24px;
      font-weight: bold;
      color: #666666;
      img {
        height: 20px;
        margin-left: 10px;
      }
    }
  }
  .live_detail {
    padding: 0;
    .live_title {
      padding: 50px 30px 0 40px;
    }
    .canvas {
      padding: 16px 40px 30px;
    }
    .introduce {
      display: flex;
      align-items: center;
      font-size: 20px;
      border-top: 1px solid #e5e5e5;
      padding: 20px 20px 40px;
      color: #666666;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url(./static/images/introduce.png) no-repeat;
        background-size: 100%;
      }
    }
  }
  .info_detail {
    margin-top: 90px;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: -60px;
      left: 50%;
      transform: translate(-50%);
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 6px solid #ffffff;
    }
    .user_name {
      padding-top: 78px;
      font-size: 36px;
      font-weight: bold;
    }
  }
  .message_div {
    padding: 30px 0;
    border-bottom: 1px dashed #e5e5e5;
    font-size: 26px;
    line-height: 40px;
    word-break: break-all;
    .message_title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .message_detail {
    .live_title {
      margin: 0;
    }
  }
  .canvas {
    display: flex;
    justify-content: space-between;
    p {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 20px;
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/index.vue